module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "part01"
    }
  }), _vm._v("PART 1")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Animate London, with smarting eyes and irritated lungs, was blinking, wheezing, and choking; inanimate London was a sooty spectre, divided in purpose between being visible and invisible, and so being wholly neither.")]), _vm._v(" "), _c('p', {
    staticClass: "right-para1"
  }, [_vm._v("—Charles Dickens")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5121f7b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 75
// module chunks = 0